import React, { useCallback } from 'react';

import { Button } from 'react-bootstrap';
import { COLORS } from '../../../styles/colors';
import { DocumentsList } from '../../../components';
import routes from '../../../routes/routes';
import styled from 'styled-components';
import styles from './MyDocuments.module.css';
import { useHistory } from 'react-router-dom';
import { useMyDocumentsQuery } from '../../../generated/graphql';

interface MyDocumentsProps {}

const AddButton = styled(Button)`
    background: ${COLORS.primary};
    border-color: ${COLORS.primary};
    color: ${COLORS.white};
    font-weight: 500;
    padding: 0.5rem 1.5rem;
    border-radius: 8px;
    transition: all 0.2s ease;

    &:hover {
        background: ${COLORS.dark};
        border-color: ${COLORS.dark};
        color: ${COLORS.white};
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
`;

const HeaderContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 1rem;
`;

export const MyDocuments: React.FC<MyDocumentsProps> = () => {
    const { data, refetch } = useMyDocumentsQuery();
    const documents = data?.me?.documents;
    const history = useHistory();

    const onCreateDocumentHandler = useCallback(() => {
        history.push(routes.createDocument);
    }, [history]);

    // if(true){
    //     return (
    //         <div
    //             style={{
    //                 height: 400,
    //                 display: 'flex',
    //                 justifyContent: 'center',
    //                 alignItems: 'center',
    //                 textAlign: 'center',
    //             }}
    //         >
    //             <h5 style={{ color: 'gray' }}>
    //                 Подача нових документів наразі недоступна
    //             </h5>
    //         </div>
    //     );
    // }

    return (
        <div className={styles.documentsContainer}>
            <HeaderContainer>
                <AddButton onClick={onCreateDocumentHandler}>Додати документ</AddButton>
            </HeaderContainer>

            {documents?.length ? (
                <DocumentsList documents={documents} refetch={refetch} />
            ) : (
                <div className={styles.emptyState}>
                    <h5 className={styles.emptyStateText}>
                        Натисніть "Додати документ" щоб додати ваш перший документ
                    </h5>
                </div>
            )}
        </div>
    );
};
